import { EVENT_LISTING_CARD_CTA, EVENT_TYPE } from "@Utils";

// The text to show on the CTA button for an event
export const getListingMainCtaText = ({
    eventType,
    customText = null,
    isProcessing,
    processingMessage,
}: {
    eventType: number;
    customText?: string | null;
    isProcessing: boolean;
    processingMessage?: string;
}): string => {
    if (isProcessing) return processingMessage || "Sending Message...";
    if (customText) return customText;

    if (eventType === EVENT_TYPE.BRANDED_COMMUNITY)
        return EVENT_LISTING_CARD_CTA.SUBSCRIBE_NOW;

    return [EVENT_TYPE.RECORDED_CONTENT, EVENT_TYPE.MERCHANDISE].includes(
        eventType
    )
        ? EVENT_LISTING_CARD_CTA.BUY_NOW
        : EVENT_LISTING_CARD_CTA.BOOK_A_SPOT;
};
